import React, { ReactNode, CSSProperties } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import tinycolor from 'tinycolor2'
import { defaultColorScheme } from '../../helpers/color_scheme_helpers'
import { BaseAdProps } from './types'

type AdWrapperProps = BaseAdProps & {
  children?: ReactNode
}

const AdWrapper: React.FC<AdWrapperProps> = ({ children, showAds, colorScheme = defaultColorScheme() }) => {
  const { height, ref } = useResizeDetector()
  const filled = !!height

  if (showAds) {
    let style: CSSProperties = {}
    let adSpacerClassName
    let adIdentifierClassName
    let adIdentifierText

    if (filled) {
      const tinyColor = tinycolor(colorScheme.primary)
      const borderColor = tinyColor.isLight()
        ? tinyColor.clone().darken(10).toHexString()
        : tinyColor.clone().lighten(10).toHexString()
      const color = tinyColor.isLight() ? tinyColor.darken(25).toHexString() : tinyColor.lighten(25).toHexString()
      style = {
        borderColor,
        color,
      }
      adSpacerClassName = 'ad-spacer'
      adIdentifierClassName = 'ad-identifier'
      adIdentifierText = 'Advertisements'
    }

    // Note: Always return the same html or Google won't fill the space
    return (
      <div className={adSpacerClassName} style={style}>
        <div className={adIdentifierClassName}>{adIdentifierText}</div>
        <div className="ad-wrapper" ref={ref}>
          {children}
        </div>
      </div>
    )
  }
  // only ever return null if showAds is false
  return null
}

AdWrapper.displayName = 'AdWrapper'

export default AdWrapper
